import React, { useCallback, useEffect, useState, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { Row, Col, Card, Table, Pagination, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { getCircleVehicleReportList, getTripReportList } from "../../redux/actions/VerifiedReportActions";
import { getMasterDriverList, getMasterUsertypeList, getMasterUsertypeUserWiseList, getMasterVehicleList, getMasterVendorList } from "../../redux/actions/MasterActions";
import RoundedPagination from "../../Components/Paginate";
import FormInput from "../../Components/FormInput";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import { getDisplayDateTimeFormat } from '../../util/generalUtills'
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { CSVLink } from 'react-csv';
import DatePicker from "react-datepicker";
import { use } from "i18next";
import { format, addDays } from "date-fns";
import Preloader from "../../Components/Preloader";
import PrintTable from "../../Components/PrintTable";
import ExportToExcel from "../../Components/ExportToExcel";


const CircleVehicleReport = () => {
  const { t } = useTranslation();
  const tableRef = useRef();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const {
    AuthReducer: { auth, errors, loading },
    verifiedReportReducer: {
      tripReportLists,
      loadingReport,
      errorsReport,
      reportCount,
    },
    masterReducer: {
      masterVehicleLists,
      masterDriverLists,
      masterVendorLists,
      masterUsertypeLists,
      loadingMaster,
      errorsMaster,
    },
  } = useSelector((state) => state);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(100);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [startDate, endDate] = dateRange;
  const [userId, setUserId] = useState("");
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    if (auth?.accessToken) {
      dispatch(getMasterUsertypeList(auth?.accessToken));
    }
  }, [auth?.accessToken, dispatch]);



  const fetchTripReportList = useCallback(() => {
    if (auth?.accessToken) {
      const formattedStartDate = startDate ? format(new Date(startDate), 'yyyy-MM-dd') : '';
      const formattedEndDate = endDate ? format(new Date(endDate), 'yyyy-MM-dd') : '';
      dispatch(getCircleVehicleReportList(auth?.accessToken, paginate, page, search, sort, formattedStartDate, formattedEndDate, userId));
    }
  }, [auth?.accessToken, paginate, page, search, sort, startDate, endDate, userId, dispatch]);

  useDebounce(fetchTripReportList, 500, [auth, paginate, page, search, sort, startDate, endDate, userId]);

  useEffect(() => {
    if (errors) {
      if (errors?.status === 401) {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }

  }, [errors, dispatch, navigate])

  useEffect(() => {
  }, [tripReportLists])

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    const formattedStartDate = startDate ? format(new Date(startDate), 'yyyy-MM-dd') : '';
    const formattedEndDate = endDate ? format(new Date(endDate), 'yyyy-MM-dd') : '';
    dispatch(getCircleVehicleReportList(auth?.accessToken, paginate, page, search, sort, formattedStartDate, formattedEndDate, userId));
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors?.data?.state_code ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errors?.data?.state_code ? 'red' : base.borderColor,
      }
    }),
  };


  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Circle Report"), path: "/Circle-Report", active: true },
        ]}
        title={t("Circle Report")}
      />

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Row>
                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Usertype")}</Form.Label>
                    <Select
                      options={masterUsertypeLists}
                      values={masterUsertypeLists?.filter(item => item.id === userId)}
                      name="user_id"
                      labelField={"roleName"}
                      valueField={"id"}
                      searchBy={"roleName"}
                      onChange={(selectedData) => setUserId(selectedData[0]?.id)}
                      styles={customSelectStyles}
                    />

                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Date")}</Form.Label>
                    <DatePicker
                      selectsRange={true}
                      dateFormat="yyyy-MM-dd"
                      startDate={startDate}
                      endDate={endDate}
                      maxDate={addDays(new Date(), 1)}
                      todayButton="Today"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      className="form-control"
                      onChange={(update) => {
                        if (update.length === 2) {
                          const date1 = new Date(update[0]);
                          date1.setHours(12, 0, 0, 0);
                          setDateRange([date1, null]);
                          if (update[1] != null) {
                            const date2 = new Date(update[1] || update[0]);
                            date2.setHours(12, 0, 0, 0);
                            setDateRange([date1, date2]);
                          }
                        }
                      }}
                      withPortal
                    />
                    {errorsMaster?.data?.startDate && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{errorsMaster?.data?.startDate}</p>
                      </div>
                    )}
                    {errorsMaster?.data?.endDate && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{errorsMaster?.data?.endDate}</p>
                      </div>
                    )}
                  </Form.Group>

                </Col>

                <Col lg={2} >
                  <div className="mb-3" style={{ marginTop: '1.6rem' }}>
                    {loadingReport ?
                      <Button color="primary" disabled>
                        <Spinner
                          className="spinner-border-sm me-1"
                          tag="span"
                          color="white"
                        />
                        Please wait ...
                      </Button>
                      :
                      <Button type="button" onClick={handleSubmit} disabled={loadingReport}>
                        Submit
                      </Button>
                    }
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <Card>
            <Card.Body>
              <div className="mb-2">
                <Row>
                  <Col lg={3}>

                  </Col>
                  <Col lg={9}>
                    <div className="d-flex justify-content-end align-items-right">
                      <Col lg={3}>
                        <Row>
                          <Col lg={2}></Col>
                          <Col lg={5}>
                            <PrintTable
                              tableId="table-to-print"
                              logoUrl="https://admin.brainbird.co.in/logo.jpg"
                              title=""
                              removeLastColumn={true}
                            />
                          </Col>
                          <Col lg={5}>
                            <ExportToExcel tableRef={tableRef} filename="data.xlsx" />
                          </Col>
                        </Row>
                      </Col>
                    </div>
                  </Col>
                </Row>
              </div>

              <div style={{ overflowY: "auto", border: "1px solid #dee2e6" }}>
                <Table
                  ref={tableRef}
                  className="mb-0 table-bordered"
                  size="sm"
                  id="table-to-print"
                  striped
                  responsive
                  style={{ width: "100%" }}
                >
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                    <tr>
                      <th></th>
                      {(() => {
                        const uniqueCircles = [...new Set((tripReportLists?.data || []).map(item => item.circleName))];
                        if (uniqueCircles.length > 0) {
                          return uniqueCircles.map((circleName, index) => (
                            <th key={index} colSpan={3}>{circleName}</th>
                          ));
                        }
                        return null;
                      })()}
                    </tr>
                    <tr>
                      <th>Date</th>
                      {(() => {
                        const uniqueCircles = [...new Set((tripReportLists?.data || []).map(item => item.circleName))];
                        if (uniqueCircles.length > 0) {
                          return uniqueCircles.map((circleName, index) => (
                            <React.Fragment key={index}>
                              <th key={`booking-${index}`}>Booking</th>
                              <th key={`tanker-${index}`}>Tanker</th>
                              <th key={`water-${index}`}>Water (K.L.)</th>
                            </React.Fragment>
                          ));
                        }
                        return (
                          <>
                            <th>Booking</th>
                            <th>Tanker</th>
                            <th>Water (K.L.)</th>
                          </>
                        );
                      })()}
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      if (!tripReportLists?.data || tripReportLists.data.length === 0) {
                        const uniqueCircles = [...new Set((tripReportLists?.data || []).map(item => item.circleName))];
                        const colSpan = uniqueCircles.length > 0 ? uniqueCircles.length * 3 + 1 : 4;
                        return (
                          <tr>
                            <td colSpan={colSpan}>No data found</td>
                          </tr>
                        );
                      }

                      const uniqueCircles = [...new Set(tripReportLists.data.map(item => item.circleName))];
                      
                      if (uniqueCircles.length > 0) {
                        // Grouped by circles (similar to CircleReport)
                        const uniqueDates = [...new Set(tripReportLists.data.map(item => item.booking_date))].sort();
                        return uniqueDates.map((date, dateIndex) => (
                          <tr key={dateIndex}>
                            <th>{date}</th>
                            {uniqueCircles.map((circleName, circleIndex) => {
                              const circleData = tripReportLists.data.find(
                                item => item.booking_date === date && item.circleName === circleName
                              );
                              return (
                                <React.Fragment key={circleIndex}>
                                  <td>{circleData?.total_count || 0}</td>
                                  <td>{circleData?.vehicle_count || 0}</td>
                                  <td>{parseFloat(circleData?.fillingVolume || 0).toFixed(2)}</td>
                                </React.Fragment>
                              );
                            })}
                          </tr>
                        ));
                      } else {
                        // Simple date-based structure (no circles)
                        const uniqueDates = [...new Set(tripReportLists.data.map(item => item.booking_date))].sort();
                        return uniqueDates.map((date, dateIndex) => {
                          const dateData = tripReportLists.data.find(item => item.booking_date === date);
                          return (
                            <tr key={dateIndex}>
                              <th>{date}</th>
                              <td>{dateData?.total_count || 0}</td>
                              <td>{dateData?.vehicle_count || 0}</td>
                              <td>{parseFloat(dateData?.fillingVolume || 0).toFixed(2)}</td>
                            </tr>
                          );
                        });
                      }
                    })()}

                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingMaster && (<Preloader />)}
      {loadingReport && (<Preloader />)}
    </>
  );
};

export default CircleVehicleReport;
